import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
import { units, measurementTypes } from "./Units";
import {v4 as uuidv4} from 'uuid';
import "../../../../styles/Widgets/AnalogueGauges/EditRadialGaugeWidget.css";
import ToogleButton from "../../../controls/ToogleButton";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { AppContext } from "../../../AppProvider";
import { color } from "chart.js/helpers";

const EditRadialGaugeWidget = () =>{
    const {user} = useContext(AppContext);
    const {activeEditWidget,setActiveEditWidget} = useContext(DashboardContext);
    const {tenantId} = useParams();
    const [devicesSummary,setDevicesSummary] = useState([]);
    const [showDevicesBrowser,setShowDevicesBrowser] = useState(false);
    const [showDataKeysBrowser,setShowDataKeysBrowser] = useState(false);
    const [selectedDataSourceType,setSelectedDataSourceType] = useState('device');
    const [selectedDataSourceDeviceSummary,setSelectedDataSourceDeviceSummary] = useState(null);
    const [selectedDataSourceDevice,setSelectedDataSourceDevice] = useState(null);
    const [selectedDataSourceDeviceId,setSelectedDataSourceDeviceId] = useState(null);
    const [dataSourceDeviceFilterString,setDataSourceDeviceFilterString] = useState('');
    const [selectedDataSourceDataKey,setSelectedDataSourceDataKey] = useState('');
    const [dataSourceDataKeyFilterString,setDataSourceDataKeyFilterString] = useState('');
    const [refreshRate,setRefreshRate] = useState('1 second');
    const [title,setTitle] = useState('');
    const [showTitle,setShowTitle] = useState(true);
    const [titleColor,setTitleColor] = useState('#000000');
    const [needleColor,setNeedleColor] = useState('#0000FF');
    const [needleEndColor,setNeedleEndColor] = useState('#008000');
    const [needleWidth,setNeedleWidth] = useState(5);
    const [needleCircleSize,setNeedleCircleSize] = useState(15);
    const [needleType,setNeedleType] = useState("arrow");
    const [minorTicks,setMinorTicks] = useState(10);
    const [borderRadius,setBorderRadius] = useState(0);
    const [mobileHeightFactor,setMobileHeightFactor] = useState(5);
    const [selectedMeasurementType,setSelectedMeasurementType] = useState(null);
    const [measurementTypeFilterString,setMeasurementTypeFilterString] = useState('');
    const [showMeasurementTypesBrowser,setShowMeasurementTypesBrowser] = useState(false);
    const [showUnitsBrowser,setShowUnitsBrowser] = useState(false);
    const [selectedUnits,setSelectedUnits] = useState(null);
    const [unitsFilterString,setUnitsFilterString] = useState('');
    const [minimumValue,setMinimumValue] = useState('');
    const [maximumValue,setMaximumValue] = useState('');
    const [decimalPlaces,setDecimalPlaces] = useState(2);
    const [displayType,setDisplayType] = useState('actual');
    const [gaugeHighlights,setGaugeHighlights] = useState([
        { id:'2aa04ae3-a5d9-4a75-839b-4d097038bcf9',from: 0, to: 10, color: "#FFFFFF"},
        { id:'310f101c-e618-4a9a-9b5b-bfb7aa7a8c4f',from: 10, to: 20, color: "#FFE5CC" },
        { id:'bf2fa38f-b549-4f72-b827-baa80b455333',from: 20, to: 30, color: "#FFCC99" },
        { id:'73d58dde-3ebd-4775-8eed-41ca686af249',from: 30, to: 40, color: "#FFB266" },
        { id:'4ab82e79-a888-4a03-95ae-78ec276184af',from: 40, to: 50, color: "#FF9933" },
        { id:'21b6a160-c0aa-4588-a4b5-c82cd79b3864',from: 50, to: 60, color: "#FF8000" },
        { id:'051d00d6-3ac1-406b-8e80-0c7c41afeb31',from: 60, to: 70, color: "#FF6600" },
        { id:'333d5648-9285-4444-a97a-c95e6740243a',from: 70, to: 80, color: "#FF4D00" },
        { id:'d73503e7-6b86-4aef-91f8-bbcf54da0215',from: 80, to: 90, color: "#F24300" },
        { id:'7ee28e34-c3c1-4f62-b7d0-e75edab0e05c',from: 90, to: 100, color: "#E63900" }
    ]);
    const [changesAvailable,setChangesAvailable] = useState(false);
    const fetchDevicesSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/devices?page=1&&limit=1000`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDevicesSummary(responseData);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when retrieving devices summary: ',error);
        }
    };
    const fetchSelectedDataSourceDevice = async() =>{
        try{
            if(!selectedDataSourceDeviceSummary || !selectedDataSourceDeviceSummary.id) return;
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/devices/${selectedDataSourceDeviceSummary?.id}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setSelectedDataSourceDevice(responseData);
            }
        }
        catch(error){
            console.error('An error occurred when retrieving the selected device: ',error);
        }
    };
    const getInvalidInputsString = () =>{
        if(!selectedDataSourceDevice?.id) return 'Please select the data source device';
        if(!selectedDataSourceDataKey?.key) return 'Please select the data key';
        if(selectedMeasurementType === null) return 'Please select a measurement type';
        if(selectedUnits === null) return 'Please select a unit to proceed';
        if(minimumValue === '' || isNaN(Number(minimumValue))) return 'Please fill in the minimum value for the gauge';
        if(maximumValue === '' || isNaN(Number(maximumValue))) return 'Please fill in the maximum value for the gauge';
        if(decimalPlaces === '' || isNaN(Number(decimalPlaces))) return 'Please fill in the number of decimal places';
        return '';
    };
    const hexToRgb = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `rgb(${r}, ${g}, ${b})`;
    };
    const getBrightness = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return (0.2126 * r + 0.7152 * g + 0.0722 * b);
    };
    const loadActiveWidget = () =>{
        setSelectedDataSourceDeviceId(activeEditWidget?.config?.dataSource?.deviceId || null);
        setSelectedDataSourceDataKey(activeEditWidget?.config?.dataSource?.dataKey?.key? {
            key:activeEditWidget?.config?.dataSource?.dataKey?.key
        }:null);
        setRefreshRate(activeEditWidget?.config?.dataSource?.refreshRate);
        setTitle(activeEditWidget?.config?.appearance?.title);
        setShowTitle(activeEditWidget?.config?.appearance?.showTitle);
        setTitleColor(activeEditWidget?.config?.appearance?.titleColor);
        setNeedleColor(activeEditWidget?.config?.appearance?.needleColor);
        setNeedleEndColor(activeEditWidget?.config?.appearance?.needleEndColor);
        setNeedleWidth(activeEditWidget?.config?.appearance?.needleWidth);
        setNeedleCircleSize(activeEditWidget?.config?.appearance?.needleCircleSize);
        setNeedleType(activeEditWidget?.config?.appearance?.needleType);
        setMinorTicks(activeEditWidget?.config?.appearance?.minorTicks);
        setBorderRadius(activeEditWidget?.borderRadius);
        setMobileHeightFactor(activeEditWidget?.mobileHeightFactor);
        setSelectedMeasurementType(activeEditWidget?.config?.data?.measurementType);
        setSelectedUnits(activeEditWidget?.config?.data?.units);
        setMinimumValue(activeEditWidget?.config?.data?.minimumValue);
        setMaximumValue(activeEditWidget?.config?.data?.maximumValue);
        setDecimalPlaces(activeEditWidget?.config?.data?.decimalPlaces);
        setDisplayType(activeEditWidget?.config?.data?.displayType);
        setGaugeHighlights((activeEditWidget?.config?.appearance?.highlights || [])
        .slice().sort((a,b) =>{
            const indexA = a?.index !== undefined? a.index:Infinity;
            const indexB = b?.index !== undefined? b.index:Infinity;
            return indexA - indexB;
        }).map((highlight) => ({
            id:uuidv4(),
            index:highlight?.index,
            from:highlight?.from,
            to:highlight?.to,
            color:highlight?.color
        })));
    };
    const checkChanges = () =>{
        if(
            selectedDataSourceDevice?.id !== activeEditWidget?.config?.dataSource?.deviceId ||
            selectedDataSourceDataKey?.key !== activeEditWidget?.config.dataSource?.dataKey?.key ||
            refreshRate !== activeEditWidget?.config?.dataSource.refreshRate ||
            title !== activeEditWidget?.config?.appearance?.title ||
            showTitle !== activeEditWidget?.config?.appearance?.showTitle ||
            titleColor?.toUpperCase() !== activeEditWidget?.config?.appearance?.titleColor ||
            needleColor?.toUpperCase() !== activeEditWidget?.config?.appearance?.needleColor ||
            needleEndColor?.toUpperCase() !== activeEditWidget?.config?.appearance?.needleEndColor ||
            needleWidth !== activeEditWidget?.config?.appearance?.needleWidth ||
            needleCircleSize !== activeEditWidget?.config?.appearance?.needleCircleSize ||
            needleType !== activeEditWidget?.config?.appearance?.needleType ||
            minorTicks !== activeEditWidget?.config?.appearance?.minorTicks ||
            borderRadius !== activeEditWidget?.borderRadius ||
            mobileHeightFactor !== activeEditWidget?.mobileHeightFactor ||
            JSON.stringify(gaugeHighlights.map(({id,...rest}) => rest)) !== JSON.stringify((activeEditWidget?.config?.appearance?.highlights || []).slice().sort((a,b) =>{
                const indexA = a?.index !== undefined? a.index:Infinity;
                const indexB = b?.index !== undefined? b.index:Infinity;
                return indexA - indexB;
            })) ||
            selectedMeasurementType !== activeEditWidget?.config?.data?.measurementType ||
            selectedUnits !== activeEditWidget?.config?.data?.units ||
            (!isNaN(Number(minimumValue))? String(minimumValue).replaceAll(',',''):'') !== String(activeEditWidget?.config?.data?.minimumValue).replaceAll(',','') ||
            (!isNaN(Number(maximumValue))? String(maximumValue).replaceAll(',',''):'') !== String(activeEditWidget?.config?.data?.maximumValue).replaceAll(',','') ||
            decimalPlaces !== activeEditWidget?.config?.data?.decimalPlaces ||
            displayType !== activeEditWidget?.config?.data?.displayType
        ) setChangesAvailable(true);
        else setChangesAvailable(false);
    };
    const setUpdatedWidget = () =>{
        const updatedRadialGauge = activeEditWidget;
        updatedRadialGauge.config = {
            dataSource:{
                deviceId: selectedDataSourceDevice?.id,
                dataKey:{
                    key:selectedDataSourceDataKey?.key
                },
                refreshRate:refreshRate
            },
            appearance:{        
                title:title,
                showTitle:showTitle,
                titleColor:titleColor,
                needleColor:needleColor,
                needleEndColor: needleEndColor,
                needleWidth:needleWidth,
                needleCircleSize:needleCircleSize,
                needleType:needleType,
                minorTicks:minorTicks,
                highlights:(gaugeHighlights || []).map((gaugeHighlight,index) => ({
                    index:index,
                    from:gaugeHighlight?.from,
                    to:gaugeHighlight?.to,
                    color:gaugeHighlight?.color
                }))
            },
            data:{
                measurementType:selectedMeasurementType,
                units:selectedUnits,
                minimumValue:minimumValue,
                maximumValue:maximumValue,
                decimalPlaces:decimalPlaces,
                displayType:displayType
            }
        }
        updatedRadialGauge.borderRadius = borderRadius;
        updatedRadialGauge.mobileHeightFactor = mobileHeightFactor;
        return updatedRadialGauge;
    };
    const resetNewRadialGaugeWidgetWindow = () =>{
        setDevicesSummary([]);
        setShowDevicesBrowser(false);
        setShowDataKeysBrowser(false);
        setSelectedDataSourceType('device');
        setSelectedDataSourceDeviceSummary(null);
        setSelectedDataSourceDevice(null);
        setSelectedDataSourceDeviceId(null);
        setDataSourceDeviceFilterString('');
        setSelectedDataSourceDataKey('');
        setDataSourceDataKeyFilterString('');
        setRefreshRate('1 second');
        setTitle('');
        setShowTitle(true);
        setTitleColor('#000000');
        setNeedleColor('#008000');
        setNeedleWidth(5);
        setNeedleCircleSize(15);
        setNeedleType("arrow");
        setMinorTicks(10);
        setBorderRadius(0);
        setMobileHeightFactor(5);
        setSelectedMeasurementType(null);
        setMeasurementTypeFilterString('');
        setShowMeasurementTypesBrowser(false);
        setShowUnitsBrowser(false);
        setSelectedUnits(null);
        setUnitsFilterString('');
        setMinimumValue('');
        setMaximumValue('');
        setDecimalPlaces(2);
        setDisplayType('actual');
        setGaugeHighlights([
            { id:'2aa04ae3-a5d9-4a75-839b-4d097038bcf9',from: 0, to: 10, color: "#FFFFFF"},
            { id:'310f101c-e618-4a9a-9b5b-bfb7aa7a8c4f',from: 10, to: 20, color: "#FFE5CC" },
            { id:'bf2fa38f-b549-4f72-b827-baa80b455333',from: 20, to: 30, color: "#FFCC99" },
            { id:'73d58dde-3ebd-4775-8eed-41ca686af249',from: 30, to: 40, color: "#FFB266" },
            { id:'4ab82e79-a888-4a03-95ae-78ec276184af',from: 40, to: 50, color: "#FF9933" },
            { id:'21b6a160-c0aa-4588-a4b5-c82cd79b3864',from: 50, to: 60, color: "#FF8000" },
            { id:'051d00d6-3ac1-406b-8e80-0c7c41afeb31',from: 60, to: 70, color: "#FF6600" },
            { id:'333d5648-9285-4444-a97a-c95e6740243a',from: 70, to: 80, color: "#FF4D00" },
            { id:'d73503e7-6b86-4aef-91f8-bbcf54da0215',from: 80, to: 90, color: "#F24300" },
            { id:'7ee28e34-c3c1-4f62-b7d0-e75edab0e05c',from: 90, to: 100, color: "#E63900" }
        ]);
    };
    const disposeWindow = () =>{
        resetNewRadialGaugeWidgetWindow();
        setActiveEditWidget(null);
    };
    const updateWidget = () =>{
        setUpdatedWidget();
        disposeWindow();
    };
    useEffect(() =>{
        if(activeEditWidget && activeEditWidget?.type === 'radial_gauge'){
            loadActiveWidget();
            fetchDevicesSummary();
        }
    },[activeEditWidget]);
    useEffect(() =>{
        if(devicesSummary && devicesSummary.length > 0 && selectedDataSourceDeviceId !== null){
            devicesSummary.forEach(deviceSummary =>{
                if(deviceSummary.id === selectedDataSourceDeviceId){
                    setSelectedDataSourceDeviceSummary(deviceSummary);
                    setSelectedDataSourceDeviceId(null);
                }
            })
        }
    },[devicesSummary]);
    useEffect(() =>{
        if(selectedDataSourceDeviceSummary){
            fetchSelectedDataSourceDevice();
        }
        else setSelectedDataSourceDevice(null);
    },[selectedDataSourceDeviceSummary]);
    useEffect(() =>{
        checkChanges();
    },[
        selectedDataSourceDevice,
        selectedDataSourceDataKey,
        refreshRate,title,showTitle,
        titleColor,needleColor,
        needleWidth,needleCircleSize,
        needleType,minorTicks,
        borderRadius,mobileHeightFactor,
        selectedMeasurementType,selectedUnits,
        minimumValue,maximumValue,decimalPlaces,
        displayType,gaugeHighlights
    ]);
    return(
        <div className="edit-radial-gauge-widget-container">
            <div className="edit-radial-gauge-widget-header-container">
                <div className="edit-radial-gauge-widget-main-header-container">
                    <div>
                        <h2>{title}</h2>
                        <p>Radial gauge</p>
                    </div>
                    <div>
                        <button
                            className="help-button"
                            title="Go to help page">?</button>
                        <button
                            className="close-editor-button"
                            onClick={() => disposeWindow()}
                            title="Close the editor">&#10006;</button>
                    </div>
                </div>
                <div className="edit-radial-gauge-widget-minor-header-container">
                    <div>
                        <button
                            title={!changesAvailable? 'No changes available':''}
                            className={changesAvailable? 'decline active':'decline inactive'}
                            onClick={() =>{if(changesAvailable) disposeWindow();}}>&#10006; Decline</button>
                        <button
                            title={!changesAvailable? 'No changes available':getInvalidInputsString()}
                            className={changesAvailable && getInvalidInputsString() === ''? 'apply active':'apply inactive'}
                            onClick={() =>{if(changesAvailable && getInvalidInputsString() === '') updateWidget();}}>&#10003; Apply</button>
                    </div>
                </div>
            </div>
            <div className="edit-radial-gauge-widget-body-container">
                <div className="edit-radial-gauge-widget-data-source-container">
                    <div className="data-source-header-container">
                        <h3>Datasource</h3>
                        <div>
                            <button
                                className={selectedDataSourceType === 'device'? 'active':''}
                                onClick={() => setSelectedDataSourceType('device')}>Device</button>
                            <button
                                className={selectedDataSourceType === 'entity-alias'? 'active':''}
                                onClick={() => setSelectedDataSourceType('entity-alias')}>Entity alias</button>
                        </div>
                    </div>
                    <div className="data-source-body-container">
                        <div className="device-selection-container">
                            <p>Device<span>*</span></p>
                            <div className="entry-container">
                                <input className={`${selectedDataSourceDevice? 'active':'inactive'}`}
                                    placeholder="Select a device"
                                    value={
                                        selectedDataSourceDevice? selectedDataSourceDevice?.name:dataSourceDeviceFilterString
                                    }
                                    onChange={(e) =>{
                                        setDataSourceDeviceFilterString(e.target.value)
                                    }}
                                    onFocus={() => setShowDevicesBrowser(true)}
                                    onBlur={() => {
                                        setTimeout(() =>{
                                            setShowDevicesBrowser(false);
                                        },200);
                                    }}
                                />
                                <p  style={{display:selectedDataSourceDeviceSummary? 'flex':'none'}}
                                    title="Remove selected device"
                                    onClick={() =>{
                                        setDataSourceDeviceFilterString('');
                                        setSelectedDataSourceDeviceSummary(null);
                                    }}>&#10006;
                                </p>
                            </div>
                            <div className={`devices-browser ${showDevicesBrowser? 'active':'none'}`}>
                                {devicesSummary && devicesSummary.length > 0 && 
                                [...devicesSummary].filter(deviceSummary => 
                                    deviceSummary?.name?.toLowerCase().includes(dataSourceDeviceFilterString.toLowerCase())
                                ).sort((a,b) => a.name.localeCompare(b.name)).map((deviceSummary,index) =>(
                                    <div key={index} onClick={(e) =>{
                                        e.stopPropagation();
                                        setSelectedDataSourceDeviceSummary(deviceSummary);
                                    }}>
                                        <p>{deviceSummary?.name}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={`data-key-selection-container ${selectedDataSourceDevice? '':'inactive'}`}>
                        <p>Data key<span>*</span></p>
                            <input
                                style={{
                                    display: `${selectedDataSourceDataKey? 'none':'block'}`
                                }}
                                placeholder={selectedDataSourceDevice? "Select a data key":"Please select a device first"}
                                value={dataSourceDataKeyFilterString}
                                readOnly={!selectedDataSourceDevice}
                                onChange={(e) =>{
                                    setDataSourceDataKeyFilterString(e.target.value);
                                }}
                                onFocus={() => setShowDataKeysBrowser(true)}
                                onBlur={() => {
                                    setTimeout(() => {
                                        setShowDataKeysBrowser(false);
                                    }, 200);
                                }}
                            />
                            <button
                                style={{
                                    display: `${selectedDataSourceDataKey? 'inline-block':'none'}`
                                }}>
                                <span className="data-key-icon">&#8623;</span>
                                <span>{selectedDataSourceDataKey? selectedDataSourceDataKey.key:'Select a data key'}</span>
                                <span
                                    className="data-key-close-icon"
                                    title="Remove data key"
                                    onClick={() =>{
                                        setDataSourceDataKeyFilterString('');
                                        setSelectedDataSourceDataKey(null)
                                    }}>&#10006;
                                </span>
                            </button>
                            <div className={`data-keys-browser ${showDataKeysBrowser? 'active':'none'}`}>
                                {selectedDataSourceDevice && 
                                selectedDataSourceDevice.latestTelemetry &&
                                selectedDataSourceDevice.latestTelemetry.filter(dataKey =>
                                    dataKey?.key.toLowerCase().includes(dataSourceDataKeyFilterString.toLocaleLowerCase())
                                ).sort((a,b) => a.key.localeCompare(b.key)).map((dataKey,index) =>(
                                    <div key={index} onClick={() =>{
                                        setSelectedDataSourceDataKey(dataKey);
                                    }}>
                                    <p onClick={() =>{
                                        setSelectedDataSourceDataKey(dataKey);
                                    }}>{dataKey.key}</p>
                                </div>))}
                            </div>
                        </div>
                        <div className="refresh-rate-container">
                            <p>Refresh rate<span>*</span></p>
                            <div className="refresh-rate-entry-container">
                                <input
                                    value={refreshRate}
                                    onChange={(e) =>{
                                        const value = e.target.value;
                                        if(value === '') setRefreshRate('');
                                        else if(/^\d+$/.test(value) && Number(value) >= 1) setRefreshRate(String(Number(value)));
                                    }}
                                    onBlur={() =>{
                                        if(refreshRate.includes(' seconds') || refreshRate.includes(' second')) return;
                                        else if(refreshRate === '' || isNaN(Number(refreshRate))) setRefreshRate('1 second');
                                        else setRefreshRate(`${Number(refreshRate)} second${Number(refreshRate) > 1? 's':''}`);
                                    }}
                                    onFocus={() =>{
                                        if(refreshRate.includes(' seconds')){
                                            const value = refreshRate.replace(' seconds','');
                                            setRefreshRate(value);
                                        }
                                        else if(refreshRate.includes(' second')){
                                            const value = refreshRate.replace(' second','');
                                            setRefreshRate(value);
                                        }
                                    }}
                                />
                                <div>
                                    <p className="increment"
                                        onClick={() =>{
                                            let currentRefreshRate = refreshRate;
                                            if(currentRefreshRate.includes(' seconds')) currentRefreshRate = currentRefreshRate.replace(' seconds','');
                                            else if(currentRefreshRate.includes( ' second')) currentRefreshRate = currentRefreshRate.replace(' second','');
                                            let currentNumericalRefreshRate = Number(currentRefreshRate);
                                            setRefreshRate(isNaN(currentNumericalRefreshRate)? '1 second':String(currentNumericalRefreshRate + 1) + ' seconds');
                                        }}>&#9650;</p>
                                    <p className="decrement"
                                        onClick={() =>{
                                            let currentRefreshRate = refreshRate;
                                            if(currentRefreshRate.includes(' seconds')) currentRefreshRate = currentRefreshRate.replace(' seconds','');
                                            else if(currentRefreshRate.includes( ' second')) currentRefreshRate = currentRefreshRate.replace(' second',''); 
                                            let currentNumericalRefreshRate = Number(currentRefreshRate);
                                            setRefreshRate(isNaN(currentNumericalRefreshRate) || currentNumericalRefreshRate <= 1? '1 second':String(currentNumericalRefreshRate - 1) + ` second${currentNumericalRefreshRate > 2? 's':''}`);
                                        }}>&#9660;</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="edit-radial-gauge-widget-appearance-container">
                    <div className="appearance-header-container">
                        <h3>Appearance</h3>
                    </div>
                    <div className="appearance-body-container">
                        <div className="title-container">
                            <div className="title-entry-container">
                                <p>Title</p>
                                <input
                                    value={title}
                                    onChange={(e) =>{
                                        setTitle(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="show-title-container">
                                <p>Show title</p>
                                <ToogleButton
                                    size="50px"
                                    marginLeft="20px"
                                    isToogled={showTitle}
                                    onChange={() => setShowTitle(!showTitle)}
                                />
                            </div>
                        </div>
                        <div className="title-color-container">
                            <p>Title color</p>
                            <div>
                                <p style={{
                                    color:titleColor,
                                    textShadow: getBrightness(titleColor) > 180? '1px 1px 1px rgba(0,0,0,1)':'none'
                                }}>{hexToRgb(titleColor)}</p>
                                <input
                                    type="color"
                                    title="Select color"
                                    value={titleColor}
                                    onChange={(e) => setTitleColor(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="needle-color-container">
                            <p>Needle color</p>
                            <div>
                                <p style={{
                                    color:needleColor,
                                    textShadow: getBrightness(needleColor) > 180? '1px 1px 1px rgba(0,0,0,1)':'none'
                                }}>{hexToRgb(needleColor)}</p>
                                <input
                                    type="color"
                                    title="Select color"
                                    value={needleColor}
                                    onChange={(e) => setNeedleColor(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="needle-end-color-container">
                            <p>Needle end color</p>
                            <div>
                                <p style={{
                                    color:needleEndColor,
                                    textShadow: getBrightness(needleEndColor) > 180? '1px 1px 1px rgba(0,0,0,1)':'none'
                                }}>{hexToRgb(needleEndColor)}</p>
                                <input
                                    type="color"
                                    title="Select color"
                                    value={needleEndColor}
                                    onChange={(e) => setNeedleEndColor(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="needle-width-container">
                            <p>Needle width</p>
                            <div>
                                <p>{needleWidth}</p>
                                <input
                                    type="range"
                                    min={1}
                                    max={15}
                                    step={1}
                                    value={needleWidth}
                                    onChange={(e) => setNeedleWidth(Number(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="needle-circle-size-container">
                            <p>Needle circle size</p>
                            <div>
                                <p>{needleCircleSize}</p>
                                <input
                                    type="range"
                                    min={1}
                                    max={20}
                                    step={1}
                                    value={needleCircleSize}
                                    onChange={(e) => setNeedleCircleSize(Number(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="needle-type-container">
                            <p>Needle Type</p>
                            <select value={needleType} onChange={(e) => setNeedleType(e.target.value)}>
                                <option value="arrow">Arrow</option>
                                <option value="line">Line</option>
                            </select>
                        </div>
                        <div className="minor-ticks-container">
                            <p>Minor ticks</p>
                            <div>
                                <p>{minorTicks}</p>
                                <input
                                    type="range"
                                    min={1}
                                    max={50}
                                    step={1}
                                    value={minorTicks}
                                    onChange={(e) => setMinorTicks(Number(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="border-radius-container">
                            <p>Border radius</p>
                            <div>
                                <p>{borderRadius}%</p>
                                <input
                                    type="range"
                                    min={0}
                                    max={100}
                                    step={1}
                                    value={borderRadius}
                                    onChange={(e) => setBorderRadius(Number(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="mobile-height-container">
                            <p>Mobile height factor</p>
                            <div>
                                <p>{mobileHeightFactor}</p>
                                <input
                                    type="range"
                                    min={1}
                                    max={10}
                                    step={0.1}
                                    value={mobileHeightFactor}
                                    onChange={(e) => setMobileHeightFactor(Number(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="edit-radial-gauge-widget-highlights-container">
                    <div className="gauge-highlights-header-container">
                        <h3>Gauge highlights</h3>
                    </div>
                    <div className="gauge-highlights-body-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>From</th>
                                    <th>To</th>
                                    <th style={{width:'25%'}}>Color</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {gaugeHighlights?.map(gaugeHighlight =>(
                                    <tr key={gaugeHighlight?.id}>
                                        <td className="gauge-highlight-from-td">
                                            <div>
                                                <input
                                                    value={gaugeHighlight?.from}
                                                    onChange={(e) =>{
                                                        if(e.target.value !== '' && (!/^\d+$/.test(e.target.value) || parseInt(e.target.value) < 0 || parseInt(e.target.value) > 100)) return;
                                                        setGaugeHighlights(prev => prev.map(g => g?.id === gaugeHighlight?.id? {...g,from:e.target.value}:g));
                                                    }}
                                                />
                                                <p>%</p>
                                            </div>
                                        </td>
                                        <td className="gauge-highlight-to-td">
                                            <div>
                                                <input
                                                    value={gaugeHighlight?.to}
                                                    onChange={(e) =>{
                                                        if(e.target.value !== '' && (!/^\d+$/.test(e.target.value) || parseInt(e.target.value) < 0 || parseInt(e.target.value) > 100)) return;
                                                        setGaugeHighlights(prev => prev.map(g => g?.id === gaugeHighlight?.id? {...g,to:e.target.value}:g));
                                                    }}
                                                />
                                                <p>%</p>
                                            </div>
                                        </td>
                                        <td className="gauge-highlight-color-td">
                                            <div>
                                                <p>{hexToRgb(gaugeHighlight?.color)}</p>
                                                <input
                                                    type="color"
                                                    value={gaugeHighlight?.color}
                                                    onChange={(e) => setGaugeHighlights(prev => prev.map(g => g?.id === gaugeHighlight?.id? {...g,color:e.target.value}:g))}
                                                />
                                            </div>
                                        </td>
                                        <td className="remove-gauge-highlight-td">
                                            <button title="Remove gauge highlight"
                                            onClick={() => setGaugeHighlights(gaugeHighlights.filter(toDeleteGaugeHighlight => toDeleteGaugeHighlight?.id !== gaugeHighlight?.id))}>
                                                <img src={`${process.env.PUBLIC_URL}/images/gray-bin-icon.png`}/>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="edit-radial-gauge-widget-data-container">
                    <div className="data-header-container">
                        <h3>Data</h3>
                    </div>
                    <div className="data-body-container">
                        <div className="measurement-type-container">
                            <p>Measurement Type<span>*</span></p>
                            <div className="entry-container">
                                <input className={selectedMeasurementType? 'active':'inactive'}
                                    title={selectedMeasurementType || measurementTypeFilterString.length === 0? "":"Invalid entry. Select a measurement from the available options"}
                                    placeholder="Select a measurement type"
                                    value={selectedMeasurementType? selectedMeasurementType:measurementTypeFilterString}
                                    onChange={(e) => setMeasurementTypeFilterString(e.target.value)}
                                    onFocus={() => setShowMeasurementTypesBrowser(true)}
                                    onBlur={() =>{
                                        setTimeout(() =>{
                                            setShowMeasurementTypesBrowser(false);
                                        },200);
                                    }}
                                />
                                <p style={{display:selectedMeasurementType? 'block':'none'}} onClick={() =>{
                                    setMeasurementTypeFilterString('');
                                    setUnitsFilterString('');
                                    setSelectedMeasurementType(null);
                                    setSelectedUnits(null);
                                }}>&#10006;</p>
                            </div>
                            <div className={`measurement-types-browser-container ${showMeasurementTypesBrowser? 'active':''}`}>
                                {measurementTypes.filter(measurementType =>
                                    measurementType.toLocaleLowerCase().includes(measurementTypeFilterString.toLowerCase())
                                ).sort((a,b) => a.localeCompare(b))
                                .map((measurementType) => (
                                    <div key={measurementType} onClick={() =>{
                                        if(selectedMeasurementType === measurementType) return;
                                        setSelectedMeasurementType(measurementType);
                                        setMeasurementTypeFilterString('');
                                        setSelectedUnits(null);
                                        setUnitsFilterString('');
                                    }}>
                                        <p>{measurementType}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="units-container">
                            <p>Units<span>*</span></p>
                            <div className="entry-container">
                                <input className={selectedUnits? 'active':'inactive'}
                                    title={selectedUnits || unitsFilterString.length === 0? "":"Invalid entry. Select a unit from the available options"}
                                    placeholder={selectedMeasurementType? "Select a unit":"Select the measurement type first"}
                                    value={selectedUnits? `${selectedUnits.name} (${selectedUnits.symbol})`:unitsFilterString}
                                    onChange={(e) => setUnitsFilterString(e.target.value)}
                                    onFocus={() => setShowUnitsBrowser(true)}
                                    onBlur={() =>{
                                        setTimeout(() =>{
                                            setShowUnitsBrowser(false);
                                        },200);
                                    }}
                                />
                                <p style={{display:selectedMeasurementType && selectedUnits? 'block':'none'}} onClick={() =>{
                                    setUnitsFilterString('');
                                    setSelectedUnits(null);
                                }}>&#10006;</p>
                            </div>
                            <div className={`units-browser-container ${showUnitsBrowser? 'active':''}`}>
                                {units[selectedMeasurementType] && (displayType === 'actual'? units[selectedMeasurementType]:[{ name: "Percentage", symbol: "%"}]).filter(unit => 
                                    unit.name.toLocaleLowerCase().includes(unitsFilterString.toLocaleLowerCase())
                                ).sort((a,b) => a?.name?.localeCompare(b?.name)).map((unit,index) =>(
                                    <div key={index} onClick={(e) =>{
                                        e.stopPropagation();
                                        setSelectedUnits(unit);
                                        setUnitsFilterString('');
                                    }}>
                                        <p>{unit.name}<span>{unit.symbol}</span></p>
                                    </div>
                                ))}
                            </div>
                            <div className="units-mask-container" style={{display:selectedMeasurementType? 'none':'block'}}></div>
                        </div>
                        <div className="minimum-value-container">
                            <p>Minimum value<span>*</span></p>
                            <input
                                placeholder="Enter the minimum value for the gauge"
                                value={minimumValue}
                                onChange={(e) =>{
                                    const value = e.target.value;
                                    if(/^-?\d*\.?\d*$/.test(value)) setMinimumValue(value);
                                }}
                                onFocus={(e) =>{
                                    setMinimumValue(minimumValue? String(minimumValue).replaceAll(',',''):'');
                                }}
                                onBlur={(e) =>{
                                    if(minimumValue === '') return;
                                    else if(!isNaN(Number(minimumValue))) setMinimumValue(Number(minimumValue).toLocaleString('en-US',{
                                        minimumFractionDigits:0,
                                        maximumFractionDigits:4
                                    }))
                                }}
                            />
                        </div>
                        <div className="maximum-value-container">
                            <p>Maximum value<span>*</span></p>
                            <input
                                placeholder="Enter the maximum value for the gauge"
                                value={maximumValue}
                                onChange={(e) =>{
                                    const value = e.target.value;
                                    if(/^-?\d*\.?\d*$/.test(value)) setMaximumValue(value);
                                }}
                                onFocus={(e) =>{
                                    setMaximumValue(maximumValue? String(maximumValue).replaceAll(',',''):'');
                                }}
                                onBlur={(e) =>{
                                    if(maximumValue === '') return;
                                    else if(!isNaN(Number(maximumValue))) setMaximumValue(Number(maximumValue).toLocaleString('en-US',{
                                        minimumFractionDigits:0,
                                        maximumFractionDigits:4
                                    }))
                                }}
                            />
                        </div>
                        <div className="decimals-container">
                            <p>Decimals<span>*</span></p>
                            <input
                                placeholder="Enter the number of decimal places (maximum is 4)"
                                value={decimalPlaces}
                                onChange={(e) =>{
                                    const value = e.target.value;
                                    if(/^\d*\.?\d*$/.test(value) && !isNaN(Number(value)) && Number(value) <= 4) setDecimalPlaces(value);
                                }}
                            />
                        </div>
                        <div className="display-container">
                            <p>Display<span>*</span></p>
                            <select
                                value={displayType}
                                onChange={(e) => setDisplayType(e.target.value)}>
                                <option value={'actual'}>Actual value</option>
                                <option value={'percentage'}>Percentage</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EditRadialGaugeWidget;